import {
	getI18n,
	i18nLoadNamespaces,
} from '@gov-nx/core/service/translations/i18n';
import type { Optional } from '@gov-nx/core/types/helpers.types';
import { useAutorizaceStore } from '@gov-nx/store/autorizace/store';

export const useProcessSuccessMessage = () => {
	const getProcessSuccessToast = useAutorizaceStore('getProcessSuccessToast');

	return async (): Promise<Optional<string>> => {
		const toast = getProcessSuccessToast();
		if (!toast) {
			return undefined;
		}

		try {
			await i18nLoadNamespaces([toast.code]);
		} catch {
			return undefined;
		}

		if (!getI18n().hasLoadedNamespace(toast.code)) {
			return undefined;
		}

		return getI18n().t(toast.key, { ns: toast.code });
	};
};
